export interface PinchPoint {
  readonly id: number;
  readonly x: number;
  readonly y: number;
}

export type PinchEvent = { kind: 'start' } | { kind: 'scale'; scale: number } | null;

export class PinchTracker {
  private readonly points = new Map<number, PinchPoint>();
  private startDistance = 0;

  public down(point: PinchPoint): PinchEvent {
    this.points.set(point.id, point);
    if (this.points.size !== 2) {
      return null;
    }
    this.startDistance = this.distance();
    return { kind: 'start' };
  }

  public move(point: PinchPoint): PinchEvent {
    if (!this.points.has(point.id)) {
      return null;
    }
    this.points.set(point.id, point);
    if (this.points.size !== 2 || this.startDistance === 0) {
      return null;
    }
    return { kind: 'scale', scale: this.distance() / this.startDistance };
  }

  public up(id: number): void {
    this.points.delete(id);
    if (this.points.size < 2) {
      this.startDistance = 0;
    }
  }

  private distance(): number {
    const [first, second] = [...this.points.values()];
    return Math.hypot(second.x - first.x, second.y - first.y);
  }
}
